// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyBQwQgbzoL-n54WcqvELVAnAHbP6moBiFo",
    authDomain: "ankit-project-1.firebaseapp.com",
    databaseURL: "https://ankit-project-1.firebaseio.com",
    projectId: "ankit-project-1",
    storageBucket: "ankit-project-1.appspot.com",
    messagingSenderId: "240999329219",
    appId: "1:240999329219:web:39d0b02e0c1f589ca9a176"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
